module.exports = __webpack_public_path__ + "static/img/g3.1ca18ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new/img/icon/g3.png
// module id = D6i1
// module chunks = 1